import LsdApiModel  from './global/LsdApiModel';
import { computed } from 'mobx';

export default class AccountingDocumentMediaModel extends LsdApiModel {
	static get path(): string {
		return '/accounting_document_media/{?id}';
	}

	@computed
	public get mediaFileName(): string {
		return this.get('mediaFileName');
	}

	@computed
	public get objectUrl() {
		return this.get('objectUrl');
	}
}
